export default __webpack_public_path__ + "static/media/top.e3427b3b.png";